import styles from "./index.module.scss";
import RowComponent from "./row.component";
import ContractLengthComponent from "./sections/contract-length.component";
import RenewalNotificationsComponent from "./sections/renewal-notifications.component";
import ConsumptionNotificationsComponent from "./sections/consumption-notifications.component";
import SendNotificationsComponent from "./sections/send-notifications.component";
import ContractSettingsForm from "./contract-settings-form";
import { percentageOptions } from "./mock-data";
import { ContractSettingsFormValues } from "./mock-data";

const ContractSettingsTable = () => {
  const handleFormStateChange = (values: ContractSettingsFormValues, isValid: boolean) => {
    
  };

  return (
    <ContractSettingsForm onFormStateChange={handleFormStateChange}>
      {({ 
        values,
        handleContractLength,
        handleRenewalNotifications,
        handleConsumptionNotifications,
        handleSendNotifications,
      }) => (
        <div className={styles.container}>
          <RowComponent title="Default Contract Length">
            <ContractLengthComponent 
              contractLength={values.contractLength}
              autoRenew={values.autoRenew}
              handleContractLength={handleContractLength}
            />
          </RowComponent>
          <RowComponent title="Renewal Notifications">
            <RenewalNotificationsComponent 
              renewalNotifications={values.renewalNotifications}
              handleRenewalNotifications={handleRenewalNotifications}
            />
          </RowComponent>
          <RowComponent title="Consumption Notifications"> 
            <ConsumptionNotificationsComponent 
              isOverSubscriptionEnabled={values.isOverSubscriptionEnabled}
              isOverProspectEnabled={values.isOverProspectEnabled}
              selectedPercentages={values.selectedPercentages}
              percentageOptions={percentageOptions}
              handleConsumptionNotifications={handleConsumptionNotifications}
            />
          </RowComponent>
          <RowComponent title="Send Notifications to:">
            <SendNotificationsComponent 
              emails={values.emails}
              handleSendNotifications={handleSendNotifications}
            />
          </RowComponent>
        </div>
      )}
    </ContractSettingsForm>
  );
};

export default ContractSettingsTable;
